
<template>
  <div class="article-list">
    <div class="article-list-head c-s">
      <div class="list-head-title">信息汇总</div>
      <div class="list-head-search c-c">
        <input type="text" placeholder="搜索关键词">
        <div class="search-img c-e van-hairline--left">
          <img src="../assets/images/images/search.png" alt="">
        </div>
      </div>
    </div>
    <div class="list-content">
      <div style="margin-top:8px;" v-for="(item, index) in articleList" :key="index">
        <HeadItem/>
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "../Interface/http.js";
import HeadItem from "../components/HeadItem.vue";
export default {
  name: "About",
  data() {
    return {
      articleList:[],
      page: 1
    };
  },
  components: {
    HeadItem
  },
  mounted(){
    this.getList();
  },
  methods:{
    getList(){
      getData("/article/list", {
        page: this.page
      }).then(res => {
        this.articleList = res.data;
      });
    }
  }
};
</script>

<style scoped>
.article-list {
  padding: 10px 15px 0;
  height: 100vh;
  box-sizing: border-box;
  background: rgb(220, 220, 220);
}
.article-list-head {
  width: 100%;
}
.list-head-title{
  font-size: 18px;
  color: #000;
}
.list-head-search {
  width: 175px;
  height: 35px;
  border-radius: 5px;
  background: #fff;
}
.list-head-search input {
  width: 100px;
}

.search-img{
  width: 35px;
  height: 24px;

}
.search-img img{
  width: 23px;
  height: 23px;
}

</style>
